/* eslint-disable react/prop-types -- project uses JSX without PropTypes package */
import { isSizingChartsMockEnabled } from "../../mocks/sizingChartsMock";

export default function SizingChartsMockBanner() {
  if (!isSizingChartsMockEnabled()) return null;
  return (
    <div
      className="mb-4 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950"
      role="status"
    >
      <strong className="font-semibold">Mock mode:</strong> sizing chart API
      calls are simulated with local data. Set{" "}
      <code className="rounded bg-white/80 px-1 text-xs">
        VITE_MOCK_SIZING_CHARTS=false
      </code>{" "}
      in{" "}
      <code className="rounded bg-white/80 px-1 text-xs">
        .env.development
      </code>{" "}
      when the backend is available again.
    </div>
  );
}
